<template>
  <div class="">

    <div class="clients-area pt-100 pb-70 custom-shape-divider">
      <div class="container p-0">
        <div class="section-title">
          <h2 v-if="!dataLoading">{{ $t('app.clients') }}</h2>
          <h2 v-if="dataLoading" class="webkit-animation col-4 offset-4 webkit-none-50"></h2>
        </div>

        <div v-if="dataLoading" class="col-12 row">
          <div class="item col-3" v-for="(item, idx) in 4" :key="idx">
            <div class="feature-item two webkit-animation webkit-none-220">
            </div>
          </div>
        </div>
        <!--  :items="5"  -->
        <carousel v-if="!dataLoading && clients && clients.length" :autoplay="true" :loop="true" :dots="false"
          :margin="20" :rtl="($i18n.locale == 'ar') ? true : false" :touchDrag="true" :items="3" :center="true"
          :responsive="{ 0: { items: 2 }, 767: { items: 2 }, 1000: { items: 3 } }" :nav="true"
          :navText="[`<i class='icofont-rounded-double-left'></i>`, `<i class='icofont-rounded-double-right'></i>`]">

          <div class="item" v-for="(item, idx) in clients" :key="idx">
            <div class="feature-item two">
              <img v-if="item.image" :src="item.image" style="width:180px;height: 180px;border-radius: 50%">
              <h3 style="margin-top: 15px">
                <a href="javascript:;">
                  {{ ($i18n.locale == 'en') ? item.en.tinyName : item.ar.tinyName }}
                </a>
              </h3>
            </div>
          </div>
        </carousel>
      </div>
    </div>

  </div>
</template>

<script>
import carousel from 'v-owl-carousel'

export default {
  name: 'Ourclients',
  components: {
    carousel
  },
  data() {
    return {
      //
      clients: [],
      pgLoading: true,
      dataLoading: true,
      refs: 'clients'
    }
  },
  mounted() {
  },
  created() {
    this.fetchService();
  },
  methods: {
    fetchService() {
      this.dataLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/companies',
        method: 'GET',
        data: {},
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.dataLoading = false;
          this.clients = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {
        });
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
